<template>
  <div class="account-wrap">
    <div class="seletc-list">
      <el-select v-model="filterData.pkgs" multiple filterable class="multiple-select" collapse-tags placeholder="选择产品" @change="clickSearch" clearable>
        <el-option v-for="item of appList" :key="item.package_name" :label="item.app_name + '（' + item.package_name + '）'" :value="item.package_name">
        </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 24px"
        multiple
        collapse-tags
        v-model="filterData.userIds"
        clearable
        placeholder="选择优化师"
        @change="clickSearch"
      >
        <el-option v-for="item of optimizerList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select style="width: 160px; margin-left: 24px" v-model="filterData.status" placeholder="选择用户状态" @change="clickSearch">
        <el-option label="全部状态" :value="-1"> </el-option>
        <el-option label="可用" :value="1"> </el-option>
        <el-option label="异常" :value="0"> </el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px; margin-left: 24px"
        value-format="yyyy-MM-dd"
        :clearable="false"
        @change="clickSearch"
      >
      </el-date-picker>
      <!-- <el-button class="submit-btn" type="primary" @click="clickSearch"
        >提交</el-button
      > -->
    </div>
    <div class="content-wrap">
      <div class="btn-list">
        <el-input
          placeholder="请输入广告账号/名称"
          prefix-icon="el-icon-search"
          v-model="filterData.search"
          class="search-input"
          style="width: 190px"
          @change="inputSearch"
        >
        </el-input>
        <el-popover placement="bottom" width="238" trigger="click" v-model="showPlBox">
          <div class="edit-budget-wrap">
            <el-form :model="budgetData" :rules="budgetRules" ref="budgetFormRef">
              <span style="font-size: 14px; color: rgba(0, 0, 0, 0.65)">预算：</span>
              <el-radio-group v-model="budgetData.budget_mode">
                <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                <el-radio label="BUDGET_MODE_DAY">指定预算</el-radio>
              </el-radio-group>
              <div class="input-wrap" v-show="budgetData.budget_mode === 'BUDGET_MODE_DAY'">
                <el-form-item prop="budget">
                  <el-input style="margin-top: 10px" placeholder="请输入预算日" v-model="budgetData.budget"></el-input>
                </el-form-item>
              </div>
              <div class="button-wrap" style="text-align: right; margin-top: 16px">
                <el-button style="height: 26px" size="mini" @click="showPlBox = false">取消</el-button>
                <el-button style="height: 26px" size="mini" type="primary" @click="editBudget">确定</el-button>
              </div>
            </el-form>
          </div>
          <template slot="reference">
            <el-button class="top-btn">
              <i class="el-icon-edit"></i>
              修改预算</el-button
            >
          </template>
        </el-popover>
        <!-- 选择字段弹框 -->
        <select-field :options="fieldOptions" :staticOptions="staticOptions" @changeColumn="generateCols" :type="10" style="margin-left: auto"></select-field>
        <el-button class="top-btn" icon="el-icon-download" style="margin-left: 16px" @click="downloadReport" :loading="downloadLoading">下载报表</el-button>
      </div>
      <div class="table-wrap">
        <el-table @selection-change="handleSelectionChange" :data="tableList" :max-height="tableMaxHeight" v-loading="loading">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column v-for="item of staticOptions" :key="item.value" :prop="item.value" :label="item.label" :min-width="item.width" :fixed="true">
            <el-table-column :prop="item.value" :label="totalColumn[item.value] != null ? String(totalColumn[item.value]) : '--'" width="200" :key="item.value">
              <template slot-scope="scope">
                <span>{{ scope.row[item.value] || "--" }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-for="item of tableCols" :key="item.value" :prop="item.value" :label="item.label" :min-width="item.width" :fixed="item.fixed">
            <el-table-column
              :prop="item.value"
              :label="totalColumn[item.value] != null ? String(totalColumn[item.value]) : '--'"
              :width="item.width"
              :key="item.value"
            >
              <template slot-scope="scope">
                <!-- 状态 -->
                <div v-if="item.value === 'status'">
                  <span v-if="scope.row.status === '可用'" class="status start">可用</span>
                  <span v-if="scope.row.status === '异常'" class="status stop">异常</span>
                </div>
                <!-- 预算 -->
                <div v-else-if="item.value === 'budget'">
                  <div v-if="scope.row.budget === '不限'">不限</div>
                  <div v-else>
                    <div>{{ scope.row.budget }}</div>
                    按日预算
                  </div>
                </div>
                <span v-else>{{ scope.row[item.value] }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="address" label="操作" fixed="right" width="180">
            <template slot-scope="scope">
              <el-button type="text" @click="checkProject(scope.row)">查看项目</el-button>
              <el-button type="text" @click="checkAd(scope.row)">查看广告</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SelectField from "@/components/selectField.vue";
import { attribute, baseData, appData } from "@/config/fieldData_ttV2";
import { getDesigner, getAdvertiserReport, updateAdvertiserBudget } from "@/api/promotionReport.js";
import { getCommonProductList } from "@/api/api.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import { formatTableList } from "../formatData.js";
import moment from "moment";
export default {
  name: "AccountTable",
  components: {
    SelectField,
  },
  data() {
    return {
      loading: false,
      appList: [],
      optimizerList: [],
      filterData: {
        pkgs: [],
        userIds: [],
        status: -1,
        time: [moment().subtract(7, "days").format("YYYY-MM-DD"), moment().subtract(1, "days").format("YYYY-MM-DD")],
        search: "",
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      fieldOptions: [
        { title: "属性数据", list: attribute.account },
        { title: "基础数据", list: baseData },
        { title: "APP数据", list: appData },
      ],
      staticOptions: [
        { label: "广告账户ID", value: "advertiserId", width: "180" },
        { label: "广告账户名称", value: "advertiserName", width: "180" },
      ],
      tableList: [],
      tableCols: [],
      tableMaxHeight: window.innerHeight - 345,
      showPlBox: false,
      budgetData: {
        budget_mode: "BUDGET_MODE_DAY",
        budget: "",
      },
      budgetRules: {
        budget: [
          {
            validator: (rule, value, callback) => {
              if (this.budgetData.budget_mode === "BUDGET_MODE_DAY") {
                let data = parseFloat(this.budgetData.budget);
                if (data >= 300) {
                  callback();
                } else {
                  callback(new Error("请输入不小于300的数字"));
                }
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      checkedList: [],
      downloadLoading: false,
      timer: null,
      totalColumn: {},
      totalReportInfo: [],
    };
  },
  mounted() {
    this.initSelectOptions();
    this.clickSearch();
  },
  watch: {
    totalReportInfo: {
      handler(value) {
        let totalData = {};
        if (value?.length > 0) {
          totalData = value[0];
        }
        totalData.advertiserId = "合计";
        totalData.advertiserName = `总共${this.pageData.total || 0}条数据`;
        totalData.status = "--";
        totalData.balance = "--";
        totalData.budget = "--";
        this.totalColumn = totalData;
      },
      immediate: true,
    },
  },
  methods: {
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.showPlBox = true;
      } else {
        this.showPlBox = false;
      }
      this.checkedList = e;
    },
    initSelectOptions() {
      getCommonProductList({ platType: 1 }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      getDesigner().then((res) => {
        if (res.code === "0000") {
          this.optimizerList = res.tags;
        }
      });
    },
    clickSearch() {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData();
    },
    formatData() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        startDate: this.filterData.time[0],
        endDate: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        parmas[key] = checkData;
      }
      return parmas;
    },
    formatTableData(list) {
      return list.map((item) => {
        //预算
        item.budget = item.budgetMode === "BUDGET_MODE_DAY" ? item.budget : "不限";
        //状态
        item.status = item.status === "1" ? "可用" : "异常";
        //通用字段
        formatTableList(item);
        return item;
      });
    },
    searchData() {
      let parmas = this.formatData();
      this.loading = true;
      getAdvertiserReport(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.tableList = this.formatTableData(res.data.pageInfo?.list || []);
          if (this.pageData.page === 1) {
            const data = JSON.parse(JSON.stringify(res.data.totalReportInfo ? [res.data.totalReportInfo] : []));
            this.totalReportInfo = this.formatTableData(data);
          }
          this.pageData.total = res.data.pageInfo?.total || 0;
        }
      });
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "status",
          "balance",
          "budget",
          "cost",
          "showCnt",
          "clickCnt",
          "ctr",
          "cpc",
          "thousandDisplayPrice",
          "activeCnt",
          "activeCost",
          "activeRate",
          "convertCnt",
          "convertCntCost",
        ];
      }
      let allFieldsMap = attribute.account.concat(baseData, appData); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    downloadReport() {
      this.downloadLoading = true;
      let parmas = this.formatData();
      delete parmas.page;
      delete parmas.size;
      getAdvertiserReport(parmas).then((res) => {
        this.downloadLoading = false;
        if (res.code === "0000") {
          const dataList = this.formatTableData(res.data.pageInfo?.list || []);
          //表头映射
          const HeaderData = {};
          this.staticOptions.concat(this.tableCols).forEach((item) => {
            HeaderData[item.value] = item.label;
          });
          downLoadWrokSheet(dataList, "投放账号.xlsx", HeaderData);
        }
      });
    },
    checkProject(rowData) {
      this.$emit("checkTable", {
        name: "ProjectTable",
        data: Object.assign({}, rowData, { time: this.filterData.time }),
      });
    },
    checkAd(rowData) {
      this.$emit("checkTable", {
        name: "AdvertiseTable",
        data: Object.assign({}, rowData, { time: this.filterData.time }),
      });
    },
    //批量修改预算
    editBudget() {
      if (this.checkedList.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
        return;
      }
      this.$refs.budgetFormRef.validate((valid) => {
        if (valid) {
          this.showPlBox = false;
          let parmas = {
            advertiser_id: this.checkedList.map((item) => item.advertiserId).join(),
            budget_mode: this.budgetData.budget_mode,
          };
          if (this.budgetData.budget_mode === "BUDGET_MODE_DAY") {
            parmas.budget = this.budgetData.budget;
          }
          updateAdvertiserBudget(parmas).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "预算修改成功",
                type: "success",
              });
              this.searchData();
            } else {
              this.$message.error("预算修改失败");
            }
          });
        }
      });
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.clickSearch();
      }, 500);
    },
  },
};
</script>

<style lang="less" scoped>
.account-wrap {
  .seletc-list {
    display: flex;
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);
    .multiple-select {
      width: 260px;
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .wenhao-icon {
      margin-left: 12px;
      cursor: pointer;
    }
    .submit-btn {
      margin-left: auto;
      padding: 0 20px;
    }
  }
  .content-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      align-items: center;
      height: 45px;
      .top-btn {
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 1);
        background: rgba(255, 255, 255, 1);
        .pl-icon {
          margin-right: 8px;
        }
      }
      .search-input {
        width: 160px;
        margin-right: 24px;
        /deep/ .el-input__icon {
          line-height: 35px;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      .status {
        display: flex;
        align-items: center;
        &::before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 4px;
        }
        &.start::before {
          background: rgba(30, 194, 57, 1);
        }
        &.stop::before {
          background: rgba(235, 49, 49, 1);
        }
      }
    }
    .page-wrap {
    }
  }
}
</style>
